import { WS_CHAT_MESSAGE_TYPES } from 'cpool-constants';

export function handleChatSocketMessageEvent(messageType: string | undefined, invalidateChat: () => void): void {
    if (messageType === WS_CHAT_MESSAGE_TYPES.MESSAGE) {
        invalidateChat();
    }
}
